var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"space-y-8 lg:space-y-12"},[_c('BasicDetailsForm',{attrs:{"project":_vm.project}}),_c('ProjectOwnerForm',{attrs:{"project":_vm.project}}),_c('ProjectProductForm',{attrs:{"project":_vm.project}}),_c('CoverForm',{attrs:{"project":_vm.project}}),_c('DeleteProjectForm',{attrs:{"project":_vm.project}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }